import React, {useEffect} from 'react'
import {
    Flex,
    VStack,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import SanitizedHtml from '../../../components/html-sanitizer'
// HOOKS
import {useParams} from 'react-router-dom'
import usePHPBKApi from '../../../custom-api/hooks/use-phpkb-api'

//UTILS
import routingObject from '../../../utils/static-routes'
import {remCalc} from '../../../theme/_utils'
import {decodeHtmlEntities} from '../../../utils/utils'

export default function ArticlePage({
    setGoBackText,
    setGoBackToPath,
    setPageTitle,
    listOfCategories,
    setIsLoading,
}) {
    const {usePHPKBGetArticle} = usePHPBKApi()
    const {article_id} = useParams() || ''
    const styles = useMultiStyleConfig('Faq', {}) || {}
    const {singleArticleStyles} = styles
    const {data, isLoading} = usePHPKBGetArticle(
        {
            article_id,
        },
        {
            enabled: Boolean(article_id),
        },
    )
    useEffect(() => {
        setIsLoading(isLoading)
    }, [isLoading])

    const article = data?.hits?.hits[0]?._source || null

    const formatCategoryName = (categoryName) => {
        return decodeHtmlEntities(categoryName).trim().replace(/\s+/g, '-').replace(/[?]/g, '')
    }

    const buildUlr = (categories, articleCategoryId) => {
        const allCategories = Object.values(categories || {})

        const topLevelMatch = allCategories.find(
            (category) => category?.category_id === articleCategoryId,
        )

        if (topLevelMatch)
            return `${routingObject.FAQ_PATH}/${formatCategoryName(
                topLevelMatch?.category_name,
            )}/t/${article?.category_id}`

        for (const category of allCategories) {
            const topics = Object.values(category?.topics || {})
            const topicMatch = topics.find((topic) => topic?.category_id === articleCategoryId)
            if (topicMatch)
                return `${routingObject.FAQ_PATH}/${formatCategoryName(
                    category?.category_name,
                )}/${formatCategoryName(topicMatch?.category_name)}/t/${topicMatch?.category_id}`
        }

        return null
    }

    useEffect(() => {
        if (article !== null) {
            const path = buildUlr(listOfCategories?.data, article?.category_id?.toString())
            setGoBackText(article?.category_name)
            setGoBackToPath(path)
            setPageTitle(article?.article_title)
        }
    }, [article])

    return (
        <VStack w="100%" h="auto" alignItems="flex-start">
            {isLoading ? (
                <></>
            ) : article ? (
                <SanitizedHtml
                    as={Flex}
                    html={article.article_content}
                    width={'100%'}
                    flexDirection="column"
                    gap={remCalc(10)}
                    sx={{
                        p: singleArticleStyles?.paragraphs,
                        li: singleArticleStyles?.listItems,
                        em: singleArticleStyles?.strongText,
                        iframe: {
                            width: '100% !important',
                            maxWidth: '100% !important',
                            height: 'auto',
                            aspectRatio: '16/9',
                        },
                    }}
                />
            ) : (
                <></>
            )}
        </VStack>
    )
}

ArticlePage.propTypes = {
    setGoBackText: PropTypes.func,
    setGoBackToPath: PropTypes.func,
    setPageTitle: PropTypes.func,
    listOfCategories: PropTypes.object,
    setIsLoading: PropTypes.func,
}
